import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { GruppoDiRicercaFormType } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { initialValuesGruppo, validationSchemaGruppo } from "./GruppoDiRicercaCommon"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"
import { useGruppoDiRicercaCreate } from "../../hooks/gruppi-di-ricerca"
import GruppoDiRicercaForm from "./GruppoDiRicercaForm"

export default function GruppoDiRicercaCreate() {
  const createGruppo = useGruppoDiRicercaCreate()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Gruppo di ricerca", href: "/gruppi-di-ricerca/gruppi-di-ricerca" }, { label: "Nuova persona" }])

  const initialValues = useMemo(() => initialValuesGruppo(), [])
  const validationSchema = useMemo(() => validationSchemaGruppo(), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova persona del gruppo di ricerca</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createGruppo.mutateAsync(values as GruppoDiRicercaFormType).then((gruppo) => {
                navigate(`/gruppi-di-ricerca/gruppi-di-ricerca/${gruppo.id}`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <GruppoDiRicercaForm />
                </Container>
                <BottomFormFixed url="/gruppi-di-ricerca/gruppi-di-ricerca"  />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
